export enum CountryCode {
  AD = 'AD',
  AG = 'AG',
  AL = 'AL',
  AR = 'AR',
  AT = 'AT',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BE = 'BE',
  BG = 'BG',
  BH = 'BH',
  BO = 'BO',
  BR = 'BR',
  BS = 'BS',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CH = 'CH',
  CL = 'CL',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  EE = 'EE',
  ES = 'ES',
  FI = 'FI',
  FO = 'FO',
  FR = 'FR',
  GB = 'GB',
  GE = 'GE',
  GF = 'GF',
  GR = 'GR',
  GT = 'GT',
  GY = 'GY',
  HN = 'HN',
  HR = 'HR',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IN = 'IN',
  IS = 'IS',
  IT = 'IT',
  JM = 'JM',
  JP = 'JP',
  KR = 'KR',
  KZ = 'KZ',
  LB = 'LB',
  LI = 'LI',
  LK = 'LK',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MK = 'MK',
  MT = 'MT',
  MX = 'MX',
  MY = 'MY',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  PA = 'PA',
  PE = 'PE',
  PL = 'PL',
  PT = 'PT',
  PY = 'PY',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  SA = 'SA',
  SE = 'SE',
  SI = 'SI',
  SK = 'SK',
  SM = 'SM',
  SR = 'SR',
  SV = 'SV',
  TH = 'TH',
  TR = 'TR',
  TT = 'TT',
  UA = 'UA',
  US = 'US',
  UY = 'UY',
  VA = 'VA',
  VE = 'VE',
  VN = 'VN',
  ZA = 'ZA',
}
